import createReactComponent from '../createReactComponent';
var SwitchCamera = createReactComponent('SwitchCamera', [['path', {
  d: 'M11 19H4a2 2 0 01-2-2V7a2 2 0 012-2h5',
  key: 'li63pu'
}], ['path', {
  d: 'M13 5h7a2 2 0 012 2v10a2 2 0 01-2 2h-5',
  key: '160mi6'
}], ['circle', {
  cx: '12',
  cy: '12',
  r: '3',
  key: '1v7zrd'
}], ['path', {
  d: 'M18 22l-3-3 3-3',
  key: '1i18z0'
}], ['path', {
  d: 'M6 2l3 3-3 3',
  key: '1re6jq'
}]]);
export default SwitchCamera;